import { render, staticRenderFns } from "./DeliveryGroup.vue?vue&type=template&id=44446865&scoped=true&"
import script from "./DeliveryGroup.vue?vue&type=script&lang=js&"
export * from "./DeliveryGroup.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryGroup.vue?vue&type=style&index=0&id=44446865&prod&lang=scss&scoped=true&"
import style1 from "./DeliveryGroup.vue?vue&type=style&index=1&id=44446865&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44446865",
  null
  
)

export default component.exports